export default __webpack_public_path__ + "static/hepatitis-c-box@2x-a309d20ac63ee832417b002958ab0e76.png";